export type AwardsType = {
  date: string;
  awardName: string;
  awardNumber?: number;
};

export const awardData: AwardsType[] = [
  {
    date: '12th Oct 2021',
    awardName: 'Birla Sun Life',
  },

  {
    date: '12th Oct 2021',
    awardName: 'HDFC Ergo',
  },

  {
    date: '12th Oct 2021',
    awardName: 'A2Z Group',
  },

  {
    date: '12th Oct 2021',
    awardName: 'Tata AIG',
  },
  {
    date: '12th Oct 2021',
    awardName: 'ICICI Lombard',
  },

  {
    date: '12th Oct 2021',
    awardName: 'HDFC Ergo',
    awardNumber: 2,
  },

  {
    date: '12th Oct 2021',
    awardName: 'HDFC Ergo',
    awardNumber: 2,
  },

  {
    date: '12th Oct 2021',
    awardName: 'Tata AIG',
    awardNumber: 2,
  },
  {
    date: '12th Oct 2021',
    awardName: 'Tata AIG',
    awardNumber: 2,
  },

  {
    date: '12th Oct 2021',
    awardName: 'Tata AIG',
  },

  {
    date: '12th Oct 2021',
    awardName: 'Chola MS',
  },

  {
    date: '12th Oct 2021',
    awardName: 'HDFC Ergo',
  },
  {
    date: '12th Oct 2021',
    awardName: 'A2Z Group',
  },

  {
    date: '12th Oct 2021',
    awardName: 'Tata AIG',
  },

  {
    date: '12th Oct 2021',
    awardName: 'Tata AIG',
    awardNumber: 3,
  },
];
